import React from 'react';

import Tag from 'eventbrite_design_system/tag/Tag';

import './DateInputTag.scss';

const DateInputTag = (tagProps) => (
    <div className="home-date-input__tag">
        <Tag {...tagProps} />
    </div>
);

export default DateInputTag;
